import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'

import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'

const app = createApp(App)

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')

// RageUX SDK — solo en desarrollo. El import dinámico dentro del guard hace que
// Rollup elimine el plugin del bundle de producción. Captura señales de runtime
// y las publica vía postMessage; no envía nada a backend. Ver src/vendor/rageux-sdk.
if (import.meta.env.DEV) {
  import('./vendor/rageux-sdk/index.js').then(({ rageux }) => rageux.init({ mode: 'global', project: 'MuellePrat' }))
}
